import { render, staticRenderFns } from "./PFormInputText.vue?vue&type=template&id=3c412225&scoped=true"
import script from "./PFormInputText.vue?vue&type=script&lang=ts"
export * from "./PFormInputText.vue?vue&type=script&lang=ts"
import style0 from "./PFormInputText.vue?vue&type=style&index=0&id=3c412225&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c412225",
  null
  
)

export default component.exports